import { Components } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import { useTheme } from "styled-components";

import { API_CALLS } from "../../../../API/api_calls";
import { Divider } from "../../../../commonStyles";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import { useAppSelector } from "../../../../redux";
import { ARTICLE_CONTENT } from "../../../../utils";
import { FlexRow } from "../../../Common/Styles";
import {
  Container,
  DropDownContainer,
  MediaDropDownContainer,
  RelativeContainer,
} from "./style";
import { mediaTypelist } from "./utils";

const MediaDropDown = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { Color, typography } = useTheme();
  const { post_id, body_content } = useAppSelector(
    (state) => state.article.draftArticle
  );
  const [isMediaDropDownOpen, setIsMediaDropDownOpen] = useState(false);

  useClickOutside({ ref, setState: setIsMediaDropDownOpen });

  return (
    <MediaDropDownContainer>
      <Divider />
      <RelativeContainer $isActive={isMediaDropDownOpen}>
        <Components.IconButton
          iconType={isMediaDropDownOpen ? "X" : "Plus"}
          disabled={false}
          kind="Secondary"
          onClick={() => {
            setIsMediaDropDownOpen(!isMediaDropDownOpen);
          }}
          size="Small"
        />
        {isMediaDropDownOpen && (
          <Container ref={ref}>
            <DropDownContainer>
              <Components.Text
                style={{ tokenStyle: typography.Body.S }}
                text="Add media to your post"
                color={Color.text["text-emphasize-brand-bolder"].value}
                fontWeight="font-weight-semibold"
              />
              <FlexRow $gapInPx={8}>
                {mediaTypelist.map(({ iconType, label, type }, index) => (
                  <Components.Tooltip key={index} type="label" label={label}>
                    <Components.IconButton
                      iconType={iconType}
                      onClick={() => {
                        setIsMediaDropDownOpen(false);
                        API_CALLS.ARTICLE.createOrUpdateArticleContent({
                          post_id,
                          content_type: ARTICLE_CONTENT[type],
                          element_role: "body",
                          article_order: body_content.length + 2,
                        });
                      }}
                      disabled={false}
                      kind="Secondary"
                      size="Medium"
                    />
                  </Components.Tooltip>
                ))}
              </FlexRow>
            </DropDownContainer>
          </Container>
        )}
      </RelativeContainer>
      <Divider />
    </MediaDropDownContainer>
  );
};

export default MediaDropDown;
